import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useCreateCustomerMutation, useCreateOrderMutation, useCreateOrderRazorpayMutation, useGetAllPaymentMethodMutation } from "../../redux/services/stripeApi";
import { getUserData, selectJwtToken } from "../../redux/slices/authSlice";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import useRazorpay from "react-razorpay";
import { useEncPaymentStringMutation } from "../../redux/services/paymentApi";
import { Button } from "@mui/material";
import { getOrderDetail, resetPaymentDetail } from "../../redux/slices/stripeSlice";
import { selectCustomerData, setCustomer } from "../../redux/slices/customerSlice";
import {
  useFindByBookingIdMutation,
  useSaveBookingDetailMutation,
} from "../../redux/services/bookingApi";
import { Formik, Form, Field } from "formik";
import { useSaveAuditLogMutation } from "../../redux/services/calculateBillingRateService";
import RegularModal from "../../components/Modals/RegularModal";
import { useExportToPDFMutation } from "../../redux/services/qrCodePdfDownloadApi";
import React from "react";
import RegularButton from "../../components/Buttons/RegularButton";
import { formatDateTime, roundNumber } from "../../redux/services/utility";
import { getOrderDetails, setCashFreePaymentDetail } from "../../redux/slices/cashFreeSlice";
import { getCartData, resetCartData } from "../../redux/slices/cartSlice";
import { getTimeZone, setFromLocation, setPaymentDetail, setToLocation } from "../../redux/slices/navSlice";
import format from "date-fns/format";
import { useFindCustomerDetailByIdMutation } from "../../redux/services/customerService";



type Props = {
  bookingDetail: any;
  parkingDetail: any;
  message: any;
};

declare global {
  interface Window {
    Cashfree: any;
  }
}

const PaymentMethod = (Props: Props) => {
  console.log(Props, "contactNumber");
  //console.log(Props?.bookingDetail?.payload?.tollCharges, "Props");
  console.log(Props?.bookingDetail?.payload?.checkinTime, Props?.bookingDetail?.payload?.checkoutTime)
  const dispatch = useAppDispatch();
  const timeZone = useAppSelector(getTimeZone);
  const cartData: any = useAppSelector(getCartData);
  console.log(cartData, "cartData");
  const navigate = useNavigate();
  const [paymentMethod, setMethodData] = useState([]);
  const [Razorpay] = useRazorpay();
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const userData = useAppSelector(getUserData);
  const cashFreeOrderId = useAppSelector(getOrderDetails);
  const customerData: any = JSON.parse(localStorage.getItem("customerDetail") || "{}");
  const [getPaymentMethod, paymentResponse] = useGetAllPaymentMethodMutation();
  const [encPaymentSringUsing, encPaymentSringUsingResponse] =
    useEncPaymentStringMutation();
  const [qrCodePDFDownload, qrCodePDFDownloadResponse] =
    useExportToPDFMutation();
  const razorPayOrderDetail = useAppSelector(getOrderDetail);
  console.log(razorPayOrderDetail, "razorPayOrderDetail");
  const [saveBookingDetail, saveBookingDetailResponse] =
    useSaveBookingDetailMutation();
  const [findBookingId, bookingIdResponse] = useFindByBookingIdMutation();
  const [bookingPayload, setBookingPayload] = useState({});
  const [auditLog, auditLogResponse] = useSaveAuditLogMutation();
  const [cashbackSucess, setCashbackSuccess] = React.useState(false);
  const [bookingSuccessData, setBookingSuccessData] = useState([]) as any;
  console.log(bookingSuccessData, "bookingSuccessData");
  const cartId: any =
    localStorage.getItem("cartId") !== "null"
      ? localStorage.getItem("cartId")
      : null;
  const customerDetails = useAppSelector(selectCustomerData);
  const country = customerDetails?.country;
  const name = customerDetails?.name;
  const address = customerDetails?.addressLine1;
  const email = customerDetails?.email;
  const mobileNo = customerDetails?.phoneNo;
  const customerCity = customerDetails?.city;
  const state = customerDetails?.state;
  const pinCode = customerDetails?.pinCode;
  const [createOrder, createOrderResponse] = useCreateOrderMutation();
  const [createCustomer, createCustomerResponse] = useCreateCustomerMutation()
  const [findCustomerDetailById, findByIdResponse] = useFindCustomerDetailByIdMutation();
  const [createOrderRazorpay, razorpayResponse] = useCreateOrderRazorpayMutation();
  const [cashfreeLoaded, setCashfreeLoaded] = useState(false);
  const finalAmount = Props?.bookingDetail?.payload?.finalAmount || 0;
  const [selectedOption, setSelectedOption] = useState() as any;
  console.log(selectedOption, "selectedOption");
  const paymentOptions = [
    { id: 0, typeName: `10%`, amount: (finalAmount * 0.10).toFixed(2), partialPayment: true },
    { id: 1, typeName: `25%`, amount: (finalAmount * 0.25).toFixed(2), partialPayment: true },
    { id: 2, typeName: `100%`, amount: finalAmount.toFixed(2), partialPayment: false },
  ];
  const storedAmount: any = localStorage.getItem('currentAmount');
  const amountToUse = selectedOption || JSON.parse(storedAmount);
  const handleSelect = (option: any) => {
    console.log(option, "option");
    setSelectedOption(option);
    localStorage.setItem('currentAmount', JSON.stringify(option));
  }


  useEffect(() => {
    if (currentUser.customerId) {
      findCustomerDetailById({
        token: token,
        id: currentUser.customerId,
      });
    }
  }, []);

  useEffect(() => {
    if (findByIdResponse.isSuccess) {
      dispatch(setCustomer(findByIdResponse.data));
      localStorage.setItem(
        "customerDetail",
        JSON.stringify(findByIdResponse.data)
      );
    }
  }, [findByIdResponse.isSuccess]);


  const getRazorpayPaymentIntent = () => {
    const receipt =
      cartId +
      "-" +
      Date.now().toString(36) +
      Math.random().toString(36).substring(2);
    const note =
      Props?.bookingDetail?.payload &&
      Props?.parkingDetail?.vehicleDetailObj?.model +
      "-" +
      Props?.bookingDetail?.payload?.checkinTime +
      "-" +
      Props?.bookingDetail?.payload?.checkoutTime;
    createOrderRazorpay({
      token: token,
      payload: {
        amount: (selectedOption.amount).toString(),
        note: note,
        receipt: receipt,
      },
    });
  };


  useEffect(() => {
    if (razorpayResponse.isError) {
    }
    if (razorpayResponse.isSuccess) {
      dispatch(setPaymentDetail(razorpayResponse.data));
      handlePayRazorpay(razorpayResponse.data);
    }
  }, [razorpayResponse.isSuccess, razorpayResponse.isError]);




  const getCahfreePaymentIntent = () => {
    createCustomer({
      token: token,
      payload: {
        customerEmail: customerData?.email,
        customerName: customerData?.name,
        customerPhone: customerData?.phoneNo ? customerData?.phoneNo : Props?.bookingDetail?.tripDetails?.contactNumber
      }
    });
  };


  useEffect(() => {
    if (createCustomerResponse.isSuccess) {
      console.log(createCustomerResponse, "createCustomerResponse");
      dispatch(resetPaymentDetail());
      const orderID =
        cartId +
        "-" +
        Date.now().toString(36) +
        Math.random().toString(36).substring(2);
      createOrder({
        token: token,
        payload: {
          customer_details: {
            customer_email: customerData?.email,
            customer_id: userData.customerId,
            customer_name: customerData?.name,
            customer_phone: customerData?.phoneNo ? customerData?.phoneNo : Props?.bookingDetail?.tripDetails?.contactNumber,
            customer_customer_uid: createCustomerResponse?.data?.customer_uid,
          },
          order_amount: selectedOption.amount,
          order_currency: "INR",
          order_id: orderID,
          order_meta: {
            additionalProp1: "",
            additionalProp2: "",
            additionalProp3: "",
          },
          order_note: "Booking for order ID : " + orderID,
        },
      });
    }

  }, [createCustomerResponse.isSuccess]);



  useEffect(() => {
    if (createOrderResponse.isError) {
    }
    if (createOrderResponse.isSuccess) {
      dispatch(setCashFreePaymentDetail(createOrderResponse.data));
      CashfreePayment(createOrderResponse.data.payment_session_id);
    }
  }, [createOrderResponse.isSuccess, createOrderResponse.isError]);

  useEffect(() => {
    const scriptUrl = "https://sdk.cashfree.com/js/v3/cashfree.js";

    const loadScript = () => {
      return new Promise<void>((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${scriptUrl}"]`);
        if (existingScript) {
          resolve();
          return;
        }

        const script = document.createElement("script");
        script.src = scriptUrl;
        script.async = true;
        script.onload = () => {
          console.log("✅ Cashfree script loaded");
          resolve();
        };
        script.onerror = () => reject("Failed to load Cashfree SDK");
        document.body.appendChild(script);
      });
    };

    loadScript()
      .then(() => {
        const interval = setInterval(() => {
          if (window.Cashfree && typeof window.Cashfree === "function") {
            console.log("✅ Cashfree SDK is now available");
            setCashfreeLoaded(true);
            clearInterval(interval);
          } else {
            console.log("⏳ Waiting for Cashfree SDK...");
          }
        }, 300);
      })
      .catch((err) => {
        console.error("❌", err);
      });
  }, []);

  const CashfreePayment = (sessionId: any) => {

    if (!cashfreeLoaded || !window.Cashfree) {
      return;
    }
    const cashfree = new window.Cashfree({ mode: "sandbox" }); // ✅ instantiate
    const checkoutOptions = {
      paymentSessionId: sessionId,
      redirectTarget: "_self",
      returnUrl: `${process.env.REACT_APP_REDIRECT_PAYMENT_URL}/profile/payment/{order_id}`,
    };

    const Data = cashfree.checkout(checkoutOptions);
    console.log(Data, "Data")
  }


  const { orderId } = useParams();
  console.log(orderId, "orderId")

  useEffect(() => {
    if (orderId && cartData && cartData?.length !== 0 && Props?.bookingDetail?.payload?.finalAmount != 0) {
      console.log("Order ID:", orderId);
      punchBooking(orderId, "ONLINE");
    } else {
      console.log("No order ID provided in URL or other conditions not met.");
      // Show general message or redirect
    }
  }, [orderId, cartData, Props?.bookingDetail?.payload?.finalAmount]);

  const handlePayRazorpay = async (razorpayResponse: any) => {
    const options: any = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      currency: "INR",
      name: "carrental",
      description: "Test Transaction",
      image:
        "https://in.spotfinder.app/static/media/spotfinder-logo.c011cf976d987b0fed29.png",
      order_id: razorpayResponse && razorpayResponse.orderId,
      amount: (selectedOption.amount).toString(),
      prefill: {
        email: customerData.email,
        contact: customerData.mobileNo,
        name: customerData.name,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
      method: {
        netbanking: true,
        card: true,
        wallet: true,
        upi: true,
      },
      config: {
        display: {
          hide: [{ method: "paylater" }, { method: "emi" }],
          preferences: { show_default_blocks: true },
        },
      },
      retry: {
        enabled: false,
      },
      handler: (res: any) => {
        punchBooking(res.razorpay_payment_id, "ONLINE");
      },
    };
    const rzp1 = new Razorpay(options);
    rzp1.on("payment.failed", function (response: any) {
      let newmessage = "Payment failed. Please try again or use a different payment method";
      Props.message(newmessage);
      // const error = response.error;
      // const failedPaymentId = error?.metadata?.payment_id;
      // punchBooking(failedPaymentId, "ONLINE");
      // console.error("Payment Failed:");
      // console.error("Transaction ID:", failedPaymentId);
      // console.error("Reason:", error.reason);
      // console.error("Description:", error.description);
    });

    rzp1.open();
  };

  useEffect(() => {
    const checkStoredAmount = async () => {
      const storedAmount = await localStorage.getItem('currentAmount');
      if (storedAmount) {
        const parsedAmount = JSON.parse(storedAmount);
        setSelectedOption(parsedAmount);
      } else {
        setSelectedOption(paymentOptions[2]);
        await localStorage.setItem('currentAmount', JSON.stringify(paymentOptions[2]));

      }
    };

    checkStoredAmount();
    getPaymentMethod({ token: token });
  }, [Props?.bookingDetail?.payload?.finalAmount]);


  useEffect(() => {
    if (paymentResponse.isSuccess) {
      let data = paymentResponse.data.filter(
        (item: any) => item.isEnable === true
      );
      setMethodData(data);
    }
  }, [paymentResponse.isSuccess]);

  const handleCCAvenue = async () => {
    let payload = `merchant_id=2625638&order_id=${cartId}&billing_name=${name}&billing_address=${address}&billing_country=${country}&billing_city=${customerCity}&billing_state=${state}&billing_zip=${pinCode}&billing_email=${email}&billing_tel=${mobileNo}&currency=INR&amount=${Props.bookingDetail.finalAmount}&redirect_url=${process.env.REACT_APP_REDIRECT_PAYMENT_URL}&cancel_url=${process.env.REACT_APP_CANCEL_URL}`;
    encPaymentSringUsing({
      token: token,
      payload: payload,
    });
  };

  useEffect(() => {
    if (encPaymentSringUsingResponse.isSuccess) {
      localStorage.setItem(
        "orderId",
        JSON.stringify(encPaymentSringUsingResponse.data.order_id)
      );
      window.open(
        `${process.env.REACT_APP_CCAVENUE_URL}=${encPaymentSringUsingResponse.data.enc_val}&access_code=${encPaymentSringUsingResponse.data.access_code}`,
        "_self"
      );
    }
    if (encPaymentSringUsingResponse.isError) {
    }
  }, [
    encPaymentSringUsingResponse.isSuccess,
    encPaymentSringUsingResponse.isError,
  ]);

  console.log("BOOKING DETAIL payment method", Props?.bookingDetail);

  function punchBooking(orderID?: any, cash?: string, paymentStatus?: string) {
    const paymentMethodId = localStorage.getItem("selectedPaymentMethod");
    console.log(Props?.bookingDetail?.tripDetails?.passengerDetails  ,"passengerDetails");
    if (Props?.bookingDetail?.tripDetails?.passengerDetails != null) {

      let payload = {
        bookingAmount: amountToUse?.amount,
        isPartialPaid: amountToUse?.partialPayment,
        bookingDate: Props?.bookingDetail?.payload?.bookingDate,
        cardAmount: Props?.bookingDetail?.payload?.finalAmount,
        cartId: cartId,
        checkinTime: Props?.bookingDetail?.payload?.checkinTime,
        checkoutTime: Props?.bookingDetail?.payload?.checkoutTime,
        parkingCategoryId: Props?.bookingDetail?.payload?.parkingCategoryId,
        convenienceFee: Props?.bookingDetail?.payload?.convenienceFee,
        fixedFee: Props?.bookingDetail?.payload?.fixedFee,
        invoiceDate: new Date().toISOString(),
        email: Props?.bookingDetail?.tripDetails?.emailId,
        phoneNo: Props?.bookingDetail?.tripDetails?.contactNumber,
        isGuest: false,
        offerDetailId: Props?.bookingDetail?.payload?.offerDetailId,
        parkingLocationId: Props?.bookingDetail?.payload?.parkingLocationId,
        rewardGained: Props?.bookingDetail?.payload?.totalBookingAmount,
        rewardUsed: Props?.bookingDetail?.payload?.redeemAmount,
        serviceProviderId: Props?.bookingDetail?.payload?.serviceProviderId,
        status: true,
        taxAmount: Props?.bookingDetail?.payload?.totalTaxAmount,
        totalAmount: Props?.bookingDetail?.payload?.finalAmount,
        transactionRefId: orderID,
        customerId: userData?.customerId ? userData?.customerId : customerData.id,
        booking: false,
        toLocation: Props?.bookingDetail?.payload?.toLocation,
        toLatitude: Props?.bookingDetail?.payload?.toLatitude,
        toLongitude: Props?.bookingDetail?.payload?.toLongitude,
        fromLatitude: Props?.bookingDetail?.payload?.fromLongitude,
        fromLocation: Props?.bookingDetail?.payload?.fromLocation,
        fromLongitude: Props?.bookingDetail?.payload?.fromLongitude,
        invoiceType: "CARD",
        isParked: false,
        paidBy: cash,
        vendorCommission: 0,
        countyTax: Props?.bookingDetail?.payload?.countyTaxAmount,
        salesTax: Props?.bookingDetail?.payload?.salesTaxAmount,
        stateTax: Props?.bookingDetail?.payload?.stateTaxAmount,
        tollCharges: Props?.bookingDetail?.payload?.tollCharges,
        userTimezone: Props?.bookingDetail?.payload?.userTimezone ? Props?.bookingDetail?.payload?.userTimezone : timeZone && timeZone[0].value,
        channel: "WEB",
        paymentStatus: paymentStatus ? paymentStatus : "pending",
        paymentMethodId: paymentMethodId,
        parkingTypeId: Props?.bookingDetail?.payload?.parkingTypeId,
        commissionAmount: 0,
        bookingStatus: "pending",
        extraAmount: 0,
        disputeResolutionDate: new Date(),
        extraAmtTransId: 0,
        uniqueBookingId: "",
        travelerDetail: [JSON.stringify(Props?.bookingDetail?.tripDetails?.passengerDetails)],

      };
      console.log(payload, "payload");
      saveBookingDetail({
        payload: [payload],
      });
      setBookingPayload(payload);
      auditLog({
        payload: {
          endTime: new Date(),
          eventName: "WEB",
          request: JSON.stringify(payload),
          response: JSON.stringify(saveBookingDetailResponse),
          serviceName: "PAYMENT_IS_START",
          startTime: new Date(),
          url: "/bookingDetail/save",
        },
      });
    }
  }

  useEffect(() => {
    if (saveBookingDetailResponse.isSuccess) {
      findBookingId({
        token: token,
        id: saveBookingDetailResponse.data[0].id,
      });
      localStorage.removeItem("bookingDetail");
      setCashbackSuccess(true);
      auditLog({
        payload: {
          cartId: cartId,
          endTime: new Date(),
          eventName: "WEB",
          request: JSON.stringify(bookingPayload),
          response: JSON.stringify(saveBookingDetailResponse),
          serviceName: "NEW_BOOKING",
          startTime: new Date(),
          url: "/bookingDetail/save",
        },
      });
    }

    if (saveBookingDetailResponse.isError) {
      let errorData: any = saveBookingDetailResponse?.error.status;
      console.log(errorData, "errorData");
      if (errorData === 417) {
        let newmessage = "There is some technical issue";
        Props.message(newmessage);
      }
      setCashbackSuccess(false);
    }
  }, [saveBookingDetailResponse.isSuccess, saveBookingDetailResponse.isError]);

  useEffect(() => {
    if (bookingIdResponse.isSuccess) {
      setBookingSuccessData(bookingIdResponse.data);
    }
  }, [bookingIdResponse.isSuccess]);

  const handleProcessed = async (payment: any, paymentMethodId: any) => {
    localStorage.setItem("selectedPaymentMethod", paymentMethodId);
    const TRID = `SF-TXNID-${cartId}`;
    console.log(payment, "payment")
    if (payment == "Razorpay") {
      getRazorpayPaymentIntent();
    }
    if (payment == "CCAvenue") {
      handleCCAvenue();
    }
    if (payment == "Cash") {
      punchBooking(TRID, "CASH");
    }
    if (payment == 'Cashfree') {
      getCahfreePaymentIntent()
    }
    if (payment == "pos") {
      punchBooking(TRID, "pos", "pending");
    }
  };

  const handleDownloadQRcode = (bookingSuccessData: any) => {
    qrCodePDFDownload({
      token: token,
      bookingId: bookingSuccessData.id,
      bookingCode: bookingSuccessData.bookingCode,
      flag: "CHECKINCHECKOUT",
      subBookingId:
        bookingSuccessData &&
        bookingSuccessData.subBookingDetailList &&
        bookingSuccessData.subBookingDetailList[0].id,
    });
  };


  useEffect(() => {
    if (qrCodePDFDownloadResponse.isSuccess) {
      console.log("qrCodePDFDownloadResponse ", qrCodePDFDownloadResponse);
      const url = window.URL.createObjectURL(new Blob([qrCodePDFDownloadResponse.data]));
      const link: any = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${formatDateTime(new Date(), "MM/DD/yyyy, hh:mm A")}, ${qrCodePDFDownloadResponse?.originalArgs?.bookingCode}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  }, [qrCodePDFDownloadResponse.isSuccess]);

  const [activeOption, setActiveOption] = useState<string | null>(null);

  const toggleAccordion = (option: string) => {
    setActiveOption(prevOption => (prevOption === option ? null : option));
  };


  return (
    <div className={" p-3 bg-[#F9F4EF] h-full"}>
      <div className={"flex-1 flex-col justify-between"}>
        <div>
          <div className={"flex flex-row justify-between p-4"}>
            {/* <h6 className={"text-[20px] font-bold text-black"}>
              Total Payable Amount
            </h6> */}
            {/**  <p className={"text-[20px] font-bold text-black"}>
              ₹ {Props?.bookingDetail?.payload?.finalAmount?.toFixed(2)}
            </p> */}

          </div>
          <div className={" bg-[#F9F4EF] flex flex-col rounded-4 "}>
            <p className="text-lg font-bold text-gray-600">
              Total Payable Amount
            </p>
            <div className="mb-4">
              {paymentOptions.map((option) => (
                <label key={option.id} className="flex items-center mb-2 cursor-pointer">
                  <input
                    type="radio"
                    name="partialPaidAmount"
                    value={option.id}
                    checked={selectedOption?.id === option.id}
                    onChange={() => handleSelect(option)}
                    className="mr-2 accent-blue-600"
                  />
                  <div className="flex gap-2">
                    <p className="font-medium">{option.typeName}</p>
                    <p className="ml-auto font-bold">₹{option.amount}</p>
                  </div>
                </label>
              ))}
            </div>

            {paymentMethod &&
              paymentMethod.map((method: any) => (
                <div
                  className={
                    "border-b border-slate-300 border-dashed last:border-b-0 cursor-pointer"
                  }
                >
                  <div
                    className={"flex m-5 flex-row items-center mb-4"}
                    onClick={() => {
                      handleProcessed(method.name, method.id);
                    }}
                  >
                    <div
                      className={
                        " mr-4 rounded-2 w-[8%] "
                      }
                    >
                      <img className={"p-2"} src={method.fileUrl} />
                    </div>
                    <div>
                      <p className={"text-gray-600 text-[16px] font-semibold"}>
                        {method.name}
                      </p>
                      <p className="text-sm">{method.description}</p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      {cashbackSucess && (
        <RegularModal
          modalDialogStyle="w-full max-w-lg rounded-lg"
          visible={cashbackSucess}
          setVisible={setCashbackSuccess}
        >
          <div className="bg-white text-black p-6 rounded-lg shadow-md flex flex-col items-center">
            <img
              className="w-20 h-20 sm:w-40 sm:h-40 s"
              src={require("../../assets/logo.png")}
              alt="Company Logo"
            />
            <div className="flex flex-col items-center text-center gap-4 mb-6">
              <img
                className="w-12 h-12"
                src={require("../../assets/success.png")}
                alt="Success Icon"
              />
              <div>
                <h1 className="text-lg sm:text-xl font-semibold text-green-600">
                  Congratulations!
                </h1>
                <p className="text-sm sm:text-base text-[#58595B]">
                  Your vehicle has been successfully reserved.
                </p>
              </div>
            </div>
            <div className="border-t border-gray-300 pt-4 space-y-2 w-full">
              <div className="flex justify-between text-xs sm:text-sm md:text-base">
                <span className="font-medium text-[#58595B]">Booking Code:</span>
                <span className="font-bold text-[#58595B]">{bookingSuccessData?.bookingCode}</span>
              </div>
              <div className="flex justify-between text-xs sm:text-sm md:text-base">
                <span className="font-medium text-[#58595B]">Pickup Date & Time:</span>
                <span className="font-bold text-[#58595B]">
                  {formatDateTime(
                    bookingSuccessData?.checkinTime,
                    "DD MMM yyyy hh:mm A"
                  )}
                </span>
              </div>
              {(Props?.bookingDetail?.payload?.serviceType === 'OutStation Round Trip' || Props?.bookingDetail?.payload?.serviceType === 'Hourly Rental') && (
                <div className="flex justify-between text-xs sm:text-sm md:text-base">
                  <span className="font-medium text-[#58595B]">Drop-off Date & Time:</span>
                  <span className="font-bold text-[#58595B]">
                    {formatDateTime(
                      bookingSuccessData?.checkoutTime,
                      "DD MMM yyyy hh:mm A"
                    )}
                  </span>
                </div>)}
            </div>
            <div className="flex justify-center items-center mt-5">
              <button
                onClick={() => {
                  localStorage.removeItem("cartId");
                  localStorage.removeItem("id");
                  localStorage.removeItem("bookingDetails");
                  localStorage.removeItem("passengerDetail");
                  localStorage.removeItem("tripDetails");
                  localStorage.removeItem('currentAmount');
                  dispatch(resetCartData());
                  dispatch(setFromLocation(null));
                  dispatch(setToLocation(null));
                  navigate("/");
                }}
                className="bg-[#ED1C24] text-white px-6 py-2 rounded-full hover:bg-[#ED1C24]">
                Done! Go Home
              </button>
              {/* <RegularButton
                onClick={() => handleDownloadQRcode(bookingSuccessData)}
                className="w-full md:w-1/2 py-3"
                title="Download QR Code"
              /> */}
            </div>
          </div>
        </RegularModal>
      )}

    </div>
  );
};
export default PaymentMethod;
